"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _regenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _default = exports.default = {
  methods: {
    /**
     * @description: 获取 表单数据
     * @return { void }
     */
    getDatas: function getDatas() {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this$model$id, _this$model, _this$form;
        var a, id, findById, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              a = {};
              id = (_this$model$id = (_this$model = _this.model) === null || _this$model === void 0 ? void 0 : _this$model.id) !== null && _this$model$id !== void 0 ? _this$model$id : (_this$form = _this.form) === null || _this$form === void 0 ? void 0 : _this$form.id;
              if (!_this.$$isEmpty(id)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (_this.url || _this.$$isNoEmpty(_this.dataSource)) {
                a = function a() {
                  var _dataSource$url, _dataSource$method;
                  var dataSource = (0, _objectSpread2.default)({}, _this.dataSource);
                  (_dataSource$url = dataSource.url) !== null && _dataSource$url !== void 0 ? _dataSource$url : dataSource.url = "".concat(_this.url.replace(/[\/]$/g, ''), "/").concat(id);
                  (_dataSource$method = dataSource.method) !== null && _dataSource$method !== void 0 ? _dataSource$method : dataSource.method = 'get';
                  return (0, _request.default)(Object.assign(dataSource));
                };
              } else {
                findById = _this.$parent.findById;
                if (typeof findById === 'function') a = findById;
              }
              if (!(typeof a !== 'function')) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _context.n = 3;
              return a(id);
            case 3:
              res = _context.v;
              if (res.code === 200) {
                Object.assign(_this.model, res.data);
                _this.$$listenersEmit('get-datas-success', res);
              } else {
                _this.$$listenersEmit('get-datas-error', res);
              }
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};